// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const MediaUploadUsage = {
  ImageStandard: {
    Name: 'Image Standard',
    Value: 'image_standard',
  },
  OrderPhoto: {
    Name: 'Order Photo',
    Value: 'order_photo',
  },
  StorefrontHero: {
    Name: 'Storefront Hero',
    Value: 'storefront_hero',
  },
  FaviconIcon: {
    Name: 'Favicon Icon',
    Value: 'favicon_icon',
  },
} as const

export type MediaUploadUsageValue =
  (typeof MediaUploadUsage)[keyof typeof MediaUploadUsage]['Value']
